import Vue from 'vue';

const state = {
    customPages: {},
    loading: true,
};

const getters = {};

// actions
const actions = {
    getCustomPageContent({ dispatch, commit, getters }, { page, brand }) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            const identifier = page + '.' + brand;
            if (typeof state.customPages[identifier] != 'undefined') {
                resolve(state.customPages[identifier])
                return;
            }
            axios.post('/api/used-vehicles/custom-pages', { page: page, brand: brand })
                .then((response) => {
                    commit('setLoading', false);
                    commit('setCustomPages', {page: page, brand: brand, data: response.data});
                    resolve();
                })
                .catch((error) => {
                    commit('setLoading', false);
                    commit('setCustomPages', {page: page, brand: brand, data: null});
                    reject(error);
                });
        });
    },
};

// mutations
const mutations = {
    setCustomPages(state, customPagesData) {
        const identifier = customPagesData.page + '.' + customPagesData.brand;
        Vue.set(state.customPages, identifier, customPagesData.data);
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};